import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './index.module.css';
import NotFoundView from '../not-found-view';
import { useFetchTranslations } from '../../api/hooks/useFetchTranslations';
import Loader from '../loader/loader';

type NotFoundErrorViewProps = {
    message: string;
};

const NotFoundErrorView = ({ message }: NotFoundErrorViewProps) => {
    // the language is hardcoded because we don't fetch the request access form data
    // where we would get the language of the user
    const language = 'en';
    const { i18n } = useTranslation();
    const { data: translations, isLoading } = useFetchTranslations(language);

    useEffect(() => {
        if (translations) {
            i18n.addResourceBundle(language, 'translation', translations, true, true);
            i18n.changeLanguage(language);
        }
    }, [translations, i18n]);

    if (isLoading) return <Loader />;

    return <NotFoundView message={message} containerClassName={styles.container} />;
};

export default NotFoundErrorView;
